export default{
    cadastra:{
        method:'post',
        url:'tabela/preco/backup'
    },
}